import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Configuration} from "../config/config";
import 'rxjs/add/operator/map';

@Injectable()
export class LearnerService {

  public jwtToken: string;
  constructor(private http: HttpClient) {
    const theUser:any = JSON.parse(localStorage.getItem('currentUser'));
    if (theUser) {
      this.jwtToken = theUser.token;
    }
  }

  getCourses(){


    return this.http.get(Configuration.ServerWithApiUrl+'/courses')
      .map((res: any)=>res)
  }

  getLatestModule(user_id, language_id){


    return this.http.get(Configuration.ServerWithApiUrl+'/transaction/'+user_id + '/' + language_id)
      .map((res: any)=>res)
  }

  getLatestJourney(user_id, language_id){
    return this.http.get(Configuration.ServerWithApiUrl+'/getRecentJourneyByUsername/'+user_id + '/' + language_id)
      .map((res: any)=>res)
  }

  getCriticalNotifications(user_id){


    return this.http.get(Configuration.ServerWithApiUrl+'/critical_notification/'+user_id)
      .map((res: any)=>res)
  }

  getSubscribedCourses(data, language_id){

    return this.http.post(Configuration.ServerWithApiUrl+'/getSubscribedCourses/' + language_id, data)
      .map((res: any)=>res)
  }

  getLatestCertificate(user_name, community_id, language_id){

    return this.http.get(Configuration.ServerWithApiUrl+'/transaction_certificate/' + user_name + '/' + community_id + '/' + language_id)
      .map((res: any)=>res)
  }

  getMessagesDetails(id){


    return this.http.get(Configuration.ServerWithApiUrl+'/message_by_id/'+id)
      .map((res: any)=>res)
  }

  dismissNotification(currentNotification){


    return this.http.put(Configuration.ServerWithApiUrl+'/dismiss_notification', currentNotification)
      .map((res: any)=>res)
  }

  getLisenseByCourse(course_id, community_id){


    return this.http.get(Configuration.ServerWithApiUrl+'/getLicenseByCourseId/'+course_id+'/'+community_id)
      .map((res: any)=>res)
  }

  getLisenceByJourney(journey_id, community_id){
    return this.http.get(Configuration.ServerWithApiUrl+'/getLicenceByJourneyId/'+journey_id+'/'+community_id)
      .map((res: any)=>res)
  }

  getCouponsByCode(code,communityId){

    return this.http.get(Configuration.ServerWithApiUrl+'/getCouponByCode/'+code+'/'+communityId)
      .map((res: any)=>res)
  }

  saveLicenseForUser(Obj){


    return this.http.post(Configuration.ServerWithApiUrl+'/saveLicenseForUser',Obj)
      .map((res: any)=>res)
  }

  updateUsedCoupos(data){


    return this.http.put(Configuration.ServerWithApiUrl+'/coupons',data)
      .map((res: any)=>res)
  }

  updateSubscribeLicense(data){


    return this.http.put(Configuration.ServerWithApiUrl+'/updateLicenseForUser',data)
      .map((res: any)=>res)
  }

  deleteExpiryMessages(licence_user_id,user_id){


    return this.http.delete(Configuration.ServerWithApiUrl+'/deleteExpiryMessage/'+licence_user_id+'/'+user_id)
      .map((res: any)=>res)
  }

  checkPassword(obj){
    return this.http.post(Configuration.ServerWithApiUrl+ '/confirmPassword', obj)
      .map((res: any)=>res)
  }

  getCourseById(course_id, lang){


    return this.http.get(Configuration.ServerWithApiUrl+'/courses/'+course_id + '/' + lang)
      .map((res: any)=>res)
  }

  getLatestCertificateById(id, lang_id){

    return this.http.get(Configuration.ServerWithApiUrl + '/getLatestCertificateById/'+id + '/' + lang_id)
      .map((res: any)=>res)
  }

  getLicenseByCertificateId(certificate_id, community_id){

    return this.http.get(Configuration.ServerWithApiUrl + '/getLicenseByCertificateId/'+certificate_id+'/'+ community_id)
      .map((res: any)=>res)
  }

  checkSubscriptionById(Obj){


    return this.http.post(Configuration.ServerWithApiUrl+'/checkSubscriptionById',Obj)
      .map((res: any)=>res)
  }

  getSelectedCommunity(commid){
    return this.http.get(Configuration.ServerWithApiUrl+'/getSelectedCommunity/'+commid)
      .map((res: any)=>res)
  }

  getLisenceCourseName(obj){
    return this.http.post(Configuration.ServerWithApiUrl+'/getLisenceCourseName',obj)
      .map((res: any)=>res)
  }
  getUserJourneys(obj){
    return this.http.post(Configuration.ServerWithApiUrl+'/userJourneys',obj)
      .map((res: any)=>res)
  }

  getAllGameData(user_id:string){
    return this.http.get(Configuration.ServerWithApiUrl+'/journeysList/users/' + user_id + '/lang/English')
  }
}
 


// WEBPACK FOOTER //
// ./src/app/Services/learner.service.ts